
import * as Actions from '../actions/smartplugControls.actions';

const initialState = [];

const smartplugControls = (state = initialState, action = {} ) => {
  switch (action.type) {
    case Actions.GET_SMARTPLUG_CONTROLS: {
      return action.payload;
    }
    case Actions.ADD_SMARTPLUG_CONTROLS: {
      return [...state, action.payload];
    }
    case Actions.UPDATE_SMARTPLUG_CONTROLS:
    case Actions.GET_SMARTPLUG_CONTROL: {
      const index = state.findIndex(
        (smartplugControl) => smartplugControl.id === action.payload.id
      );
      const newState = state;
      newState[index > -1 ? index : state.length] = action.payload;
      return [...newState];
    }
    case Actions.REMOVE_SMARTPLUG_CONTROLS: {
      return state.filter((obj) => obj.id !== action.payload.id);
    }
    default:
      return state;
  }
};

export default smartplugControls;
